import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { AlertCircleIcon, InfoIcon, ArrowRightIcon } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function AnnouncementsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="announcements" className="py-24 bg-background relative z-30" ref={ref} data-id="element-69">
      <div className="container mx-auto px-4" data-id="element-70">
        <motion.div className="text-center mb-16" initial="hidden" animate={isInView ? 'visible' : 'hidden'} variants={fadeInUp} transition={{
        duration: 0.6
      }} data-id="element-71">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-foreground mb-6" data-id="element-72">
            Important Announcements
          </h2>
          <div className="w-24 h-1.5 bg-[#006233] mx-auto rounded-full" data-id="element-73"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-6xl mx-auto" data-id="element-74">
          {/* Election Announcement */}
          <motion.div className="bg-card rounded-xl shadow-lg border border-border/50 overflow-hidden flex flex-col h-full hover:shadow-xl transition-all duration-300 group relative" initial="hidden" animate={isInView ? 'visible' : 'hidden'} variants={fadeInUp} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-75">
            <div className="h-2 w-full bg-[#ED1C24]" data-id="element-76"></div>
            <div className="p-8 md:p-10 flex-1 flex flex-col" data-id="element-77">
              <div className="flex items-start gap-6 mb-6" data-id="element-78">
                <div className="p-4 bg-red-50 dark:bg-red-950/30 rounded-2xl text-[#ED1C24] shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-79">
                  <AlertCircleIcon className="w-8 h-8" data-id="element-80" />
                </div>
                <div data-id="element-81">
                  <h3 className="text-2xl font-bold text-foreground mb-3 leading-tight" data-id="element-82">
                    LEBANON'S PARLIAMENTARY ELECTION 2026
                  </h3>
                  <p className="text-muted-foreground mb-6 text-lg leading-relaxed" data-id="element-83">
                    Check your eligibility and proof any incorrect details,
                    submit before{' '}
                    <strong className="text-foreground font-bold" data-id="element-84">
                      20/02/2026
                    </strong>
                    . The release of preliminary electoral lists for 2026
                    parliamentary elections for voters residing abroad.
                  </p>
                  <div className="mt-6 p-5 bg-muted/50 rounded-lg border border-border/50" data-id="element-85">
                    <p dir="rtl" className="text-right text-xl text-foreground font-medium leading-relaxed font-serif" data-id="element-86">
                      صدور القوائم الانتخابية الأولية العائدة للانتخابات
                      النيابية عام 2026 للمنتخبين المقيمين في الخارج
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-auto pt-8" data-id="element-87">
                <a href="#services" className="inline-flex items-center text-[#ED1C24] hover:text-red-800 font-bold text-lg transition-colors" data-id="element-88">
                  Learn More{' '}
                  <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" data-id="element-89" />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Fees Announcement */}
          <motion.div className="bg-card rounded-xl shadow-lg border border-border/50 overflow-hidden flex flex-col h-full hover:shadow-xl transition-all duration-300 group relative" initial="hidden" animate={isInView ? 'visible' : 'hidden'} variants={fadeInUp} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-90">
            <div className="h-2 w-full bg-[#006233]" data-id="element-91"></div>
            <div className="p-8 md:p-10 flex-1 flex flex-col" data-id="element-92">
              <div className="flex items-start gap-6 mb-6" data-id="element-93">
                <div className="p-4 bg-emerald-50 dark:bg-emerald-950/30 rounded-2xl text-[#006233] shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-94">
                  <InfoIcon className="w-8 h-8" data-id="element-95" />
                </div>
                <div data-id="element-96">
                  <h3 className="text-2xl font-bold text-foreground mb-3 leading-tight" data-id="element-97">
                    New Consular Fees
                  </h3>
                  <p className="text-muted-foreground mb-6 text-lg leading-relaxed" data-id="element-98">
                    Please be advised that new consular fees will be applicable
                    starting from{' '}
                    <strong className="text-foreground font-bold" data-id="element-99">
                      01 March 2026
                    </strong>
                    . Ensure you review the updated fee schedule before
                    submitting any new applications or requests.
                  </p>
                </div>
              </div>
              <div className="mt-auto pt-8" data-id="element-100">
                <a href="#services" className="inline-flex items-center text-[#006233] hover:text-emerald-800 font-bold text-lg transition-colors" data-id="element-101">
                  View Fee Schedule{' '}
                  <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" data-id="element-102" />
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}